/* eslint-disable no-var */
/********************************************************
 * VDM ADMIN INTERFACE
 *
 * tool allows buildout and administration of the
 * Warfel VDM application
 *
 ********************************************************/

/**********************************************
 DEPENDENCIES
**********************************************/

var $ = require('jquery');
var page = require('page');
var utils = require('Utilities/utils');
var api = require('Modules/api');
var auth = require('Modules/auth');
var ds = require('Modules/data_store');

// import Ractive and set debug mode to only work when not minified
var Ractive = require('ractive');
Ractive.DEBUG = /unminified/.test(function() {
    /*unminified*/
});

/**********************************************
 VARIABLES
**********************************************/

var community; // used for error handling if we have to reroute back to community lp

/**********************************************
 AUTHENTICATION CHECK
**********************************************/

// Check if there is a current session and if it is still valid, if not, require login.
var authCheck = function(ctx) {
    if (auth.checkSessionStore()) {
        auth.verify('/api/app/auth/verify').done(function(data) {
            if (data.success) {
                api.set_header('Authorization', ds.get('token'));
                ctx.params.tkn_valid = true;
                data_request.configurator(ctx);
            } else state.login(ctx);
        });
    } else state.login(ctx);
};

/**********************************************
 HELPERS
**********************************************/

// helpers might find themselves moved into a seperate module
var helpers = {
    search_array_of_objects: function(key, value, array) {
        /* searches array of objects for an object with a certain key value
		 returns the matching object or false if no match */
        //var success;

        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return false;
    }
};

/**********************************************
 DATA GRAB FUNCTIONS
**********************************************/

// Data Request methods retrieve needed data and pass on to route handlers
var data_request = {
    default_page: function(ctx, next) {
        // get default page data
        api.default_page().done(function(data) {
            // update ctx with default page data
            ctx.params.default_data = data.data;

            // pass on to next step
            next();
        });
    },

    community_url_check: function(ctx, next) {
        // passed parameter
        var com = ctx.params.community;
        community = com;

        // get community data
        api.community_list().done(function(data) {
            var com_data = data.data;

            // check if valid data
            var com_active = helpers.search_array_of_objects(
                'url_route',
                com,
                com_data
            );

            if (com_active) {
                // update ctx with comm id (eventually use data_store module)
                ctx.params.id = com_active.id;

                // pass on to next step
                next();
            } else {
                // push error to console and redirect to default view
                console.error(
                    'Invalid community url! Community url "' +
                        com +
                        '" does not exist.'
                );
                page.redirect('/');
            }
        });
    },

    community_landing_page: function(ctx, next) {
        // community id
        var id = ctx.params.id;

        // get community landing page
        api.landing_page(id).done(function(data) {
            // add data to ctx before passing on
            ctx.params.lp_data = data.data;
            next();
        });
    },

    unit_load: function(ctx, next) {
        var comm_id = ctx.params.id;
        var unit = ctx.params.unit;
        var lp_data = {};
        var need_lp = ctx.init ? true : false;

        // get unit list data
        api.unit_direct(comm_id, need_lp).done(function(data) {
            if (ctx.init) {
                //unit page loaded first so we need basic info for page draw
                lp_data = data.data['landing_page_data'];
            }
            ctx.params.lp_data = data.data;

            if (data.data['units_data']) {
                // check if valid unit
                var unit_active = helpers.search_array_of_objects(
                    'url',
                    unit,
                    data.data['units_data']
                );

                if (unit_active) {
                    // update ctx with unit id
                    ctx.params.unit_id = unit_active.id;

                    // pass on to next step
                    next();
                } else {
                    console.error(
                        'invalid unit url! Unit "' + unit + '" does not exist.'
                    );
                    page.redirect('/');
                }
            } else {
                console.error('invalid community id requested by API!');
                page.redirect('/');
            }
        });
    },

    configurator: function(ctx) {
        // clear container and add loading screen
        state.loading();

        // community id
        var id = ctx.params.unit_id;

        // get configurator unit data
        api.unit(id).done(function(data) {
            // pass on ctx and data
            state.configurator(ctx, data.data);
        });

        // TEMP have a small delay here for the cover
        //setTimeout( function() {}, 350);
    }
};

/**********************************************
 STATE CONTROLER
**********************************************/

// Route/State Handlers activate view modules
var state = {
    loading: function(msg) {
        msg = msg || 'Loading...';

        $('.loader_msg').text(msg);
        $('body').addClass('loading');
        //$('#container').html('');
    },

    done_loading: function() {
        $('#loader_container').addClass('slow-fade-out');
        setTimeout(function() {
            $('body').removeClass('loading');
            $('#loader_container').removeClass('slow-fade-out');
        }, 300);
    },

    login: function(ctx) {
        // import view module
        var view_lp = require('Views/landing_page');
        console.log(ctx);
        // build out data to send to module
        var login_data = ctx.params.lp_data;
        login_data.unit_id = ctx.params.unit_id;
        login_data.state = 'state--login';
        login_data.init = ctx.init;

        // activate landing page view
        view_lp.show_login(login_data, state.done_loading);
        view_lp.login_complete(function() {
            data_request.configurator(ctx);
        });
    },

    index: function(ctx) {
        // import view module
        var view_default = require('Views/default');

        // activate default view
        view_default(ctx.params.default_data, state.done_loading);
    },

    community_landing_page: function(ctx) {
        // import view module
        var view_lp = require('Views/landing_page');

        // build out data to send to module
        var lp_data = ctx.params.lp_data;
        lp_data.state = 'state--list';

        // activate landing page view
        view_lp.show_lp(lp_data, state.done_loading);
    },

    error404: function(ctx) {
        console.error('404 Error', 'This url is invalid!');
        page.redirect('/');
    },

    configurator: function(ctx, config_data) {
        console.log('************ launch configurator **************');

        // import view module
        var view_configurator = require('Views/configurator');

        // launch configurator
        view_configurator.show(
            ctx,
            config_data,
            state.loading,
            state.done_loading
        );
    }
};

/**********************************************
 SOME APPLICATION INITIALIZATION
**********************************************/

// if code minified then turn off Ractive debug
Ractive.DEBUG = /unminified/.test(function() {
    /*unminified*/
});

// define data call api settings
api.set_options({
    forbidden: function(t, m) {
        alert(t + '\n\n' + m);
        page('/' + community);
    },
    api_base: '/api/app/'
});

/**********************************************
 APPLICATION ROUTING
**********************************************/

// Define routes
page('/error', state.error404);
page(
    '/:community',
    data_request.community_url_check,
    data_request.community_landing_page,
    state.community_landing_page
);
page(
    '/:community/:unit',
    data_request.community_url_check,
    data_request.unit_load,
    authCheck
);
page('/', data_request.default_page, state.index);
page('*', data_request.default_page, state.index);
page();
